export default {"src":"/_next/static/media/arrowDown.3241a03c.svg","height":6,"width":11,"blurWidth":0,"blurHeight":0};